/**
 * El ancla de la card "Portales inmobiliarios" de la ficha.
 *
 * Vive sola, en su propio módulo, porque la usan dos lados que no se importan entre sí:
 * `PropertyActionsGrid` la pone como `id` de la sección, y la burbuja de Gustavo
 * (`propertyInsight`) arma el link que lleva hasta ahí. Si fuera un string escrito en
 * cada lado, el chip dejaría de scrollear el día que alguien renombre la sección y nada
 * lo diría.
 */
export const ANCLA_PORTALES = 'portales-inmobiliarios';
